import React from 'react'
import PropTypes from 'prop-types'
import { midas } from '@resurs/midas'
import { Button } from '../../Button'
import styles from './sortingTable.style'

export class SortingTable extends React.PureComponent {
  static toggleDirection(direction) {
    if (direction === 'asc') {
      return 'desc'
    }
    return 'asc'
  }

  constructor(props) {
    super(props)
    this.state = {
      lastSort: null,
      direction: 'asc',
    }
  }

  onColClick(e) {
    e.preventDefault()
    const headerId = e.target.id

    if (!headerId) {
      return
    }
    let direction = 'asc'

    if (this.state.lastSort === headerId) {
      direction = SortingTable.toggleDirection(this.state.direction)
    }

    this.setState({
      lastSort: headerId,
      direction,
    })

    this.props.onChangeSortPriority(headerId, direction)
  }

  caret(index) {
    if (this.props.headerIds[index] === this.state.lastSort) {
      if (this.state.direction === 'desc') {
        return (
          <i
            style={styles.desc}
            className={`${midas.icon} ${midas.iconCaret} ${midas.ml10}`}
          />
        )
      }
      return <i className={`${midas.icon} ${midas.iconCaret} ${midas.ml10}`} />
    }
    return null
  }

  render() {
    return (
      <table
        style={{ whiteSpace: 'nowrap' }}
        className={`${midas.table} ${midas.tableStriped} ${midas.tableHover}`}
      >
        <thead>
          <tr style={styles.header}>
            {this.props.headers.map((header, index) => {
              if (header.type === 'button') {
                return (
                  <th id={this.props.headerIds[index]} key={header.text}>
                    <Button
                      onClick={e => header.onClick(e)}
                      text={header.text}
                    />
                  </th>
                )
              }
              if (header.type === 'icon') {
                return (
                  <th
                    style={{ color: header.color, textAlign: 'center' }}
                    id={this.props.headerIds[index]}
                    key={header.text}
                    onClick={e => this.onColClick(e)}
                  >
                    <i className={header.classString} />
                    {this.state.lastSort && this.caret(index)}
                  </th>
                )
              }
              if (header.type === 'number') {
                return (
                  <th
                    id={this.props.headerIds[index]}
                    key={header}
                    onClick={e => this.onColClick(e)}
                    style={{ textAlign: 'right', paddingRight: '2rem' }}
                  >
                    {header.text}
                    {this.state.lastSort && this.caret(index)}
                  </th>
                )
              }
              return (
                <th
                  id={this.props.headerIds[index]}
                  key={header}
                  onClick={e => this.onColClick(e)}
                >
                  {header}
                  {this.state.lastSort && this.caret(index)}
                </th>
              )
            })}
          </tr>
        </thead>
        <tbody>{this.props.children}</tbody>
      </table>
    )
  }
}

SortingTable.propTypes = {
  headers: PropTypes.array.isRequired,
  headerIds: PropTypes.array.isRequired,
  onChangeSortPriority: PropTypes.func.isRequired,
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.array])
    .isRequired,
}
